import { createSlice } from '@reduxjs/toolkit';

interface IntegrationState {
    resyncLoading: boolean;
    resyncStatus: string; // 'idle' | 'in_progress' | 'completed' | 'failed' | 'timeout'
    resyncError: string | null;
    lastSyncedAt: string;
}

const initialState: IntegrationState = {
    resyncLoading: false,
    resyncStatus: 'idle',
    resyncError: null,
    lastSyncedAt: '',
};

export const integrationSlice = createSlice({
    name: 'integration',
    initialState,
    reducers: {
        setResyncLoading: (state, action) => {
            state.resyncLoading = action.payload;
        },
        setResyncStatus: (state, action) => {
            state.resyncStatus = action.payload;
        },
        setResyncError: (state, action) => {
            state.resyncError = action.payload;
        },
        setLastSyncedAt: (state, action) => {
            state.lastSyncedAt = action.payload;
        },
        resetResyncState: (state) => {
            state.resyncLoading = false;
            state.resyncStatus = 'idle';
            state.resyncError = null;
            state.lastSyncedAt = '';
        },
    },
});

export const {
    setResyncLoading,
    setResyncStatus,
    setResyncError,
    setLastSyncedAt,
    resetResyncState,
} = integrationSlice.actions;

export default integrationSlice.reducer;
